/**
 * Trigger a reflow
 * @param {HTMLElement} element to trigger a reflow.
 */
export default function reflow(element) {
  new Function('bs', 'return bs')(element.offsetHeight);
}



/** WEBPACK FOOTER **
 ** D:/Node/audi-ui/~/eslint-loader!./src/util/reflow.js
 **/